export const TABLE_TYPES = {
  SIMPLE: 'SIMPLE',
  MULTIPLE: 'MULTIPLE',
  RANKING_TABLE: 'RANKING_TABLE',
  TURNOVER: 'TURNOVER',
  GROUP: 'GROUP',
  GROUP_TURNOVER: 'GROUP_TURNOVER',
  SECURED_BORROWING: 'SECURED_BORROWING'
};
